<template>

    <div class="text-sm">

        <div class="flex flex-row justify-between items-start gap-x-8">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-medium flex items-center gap-x-2">Outgoing recordings: Only Workspace Members +
                    Selected Individuals Can Watch
                    <UpgradePlan v-if="!plan_secure_sharing" />
                </div>

                <div class="text-sm mt-3">When enabled, helpdesk recordings prompt agents to choose viewers at recording
                    time, whereas Chrome Extension videos default to workspace-only—agents can still add any external
                    email later via the Birdie Workspace.<br />
                    Individuals outside the workspace will receive a secure link via email to access the recording -
                    <docs-link
                        href="https://docs.birdie.so/birdie-docs/security/recordings-privacy-settings/outgoing-recordings-only-workspace-members-+-selected-individuals-can-watch" />
                </div>

            </div>

            <div class="flex flex-shrink">
                <toggle :checked="secure_sharing_enabled && plan_secure_sharing" @click.prevent.stop
                    :disabled="!plan_secure_sharing" @update="toggleWatch"></toggle>
            </div>
        </div>

    </div>

</template>






<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan.vue'


export default {

    props: [],

    components: {
        Toggle,
        UpgradePlan
    },

    data() {
        return {
            plan_secure_sharing: this.$page.props.plan_secure_sharing,
            secure_sharing_enabled: false,
            saving: false,
        }
    },

    created() {

        if (this.$page.props.user.current_team.metadata) {
            const metadata = JSON.parse(this.$page.props.user.current_team.metadata)
            if (metadata.secure_sharing_enabled) {
                this.secure_sharing_enabled = metadata.secure_sharing_enabled
            }
        }
    },
    computed: {
    },
    mounted() {

    },
    methods: {

        toggleWatch: function () {
            if (!this.plan_secure_sharing || this.saving) {
                return
            }
            this.secure_sharing_enabled = !this.secure_sharing_enabled
            this.updateMeta({
                meta: "secure_sharing_enabled",
                value: this.secure_sharing_enabled
            })
        },
        updateMeta: function (params) {
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        }
    }

}

</script>
